import React, { useEffect, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { base_url } from "./admin/components/AdminUsers";
import axios from "axios";
import { useTheme } from "../context/ThemeContext";
import Offcanvas from 'react-bootstrap/Offcanvas';

const LoginModal = ({ show, handleClose }) => {
    const [loading, setLoading] = useState(true);
    const [modalPath, setModalPath] = useState('');
    const themeColors = useTheme();

    const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 991);

    const fetchModal = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${base_url}/api/webapi/fetchModal`, {
                // withCredentials: true,
                headers: {
                    "content-type": "application/json",
                },
            });
            const data = response.data.data.result[0];
            console.log("Fetched logo data:", data);

            if (data && data.image) {
                setModalPath(data.image);
            }
        } catch (error) {
            console.error("API Error:", error);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchModal();
    }, [])

    return (
        <>
            <style>
                {`
                   .offcanvas-header{
                    background-color: #08c !important;
                   }
                    .offcanvas-centered-x {
                        left: 50% !important;
                        transform: translateX(-50%) !important;
                    }
 
                    @media (max-width: 768px) {
                      .offcanvas-centered-x {
                        left: 50% !important;
                        transform: translateX(-50%) !important;
                    }  
                    }
                `}
            </style>

            <div style={{ width: "100%" }}>
                <Offcanvas
                    show={show}
                    onHide={handleClose}
                    placement="top"
                    className="offcanvas-centered-x"
                    style={{
                        height: "100vh",
                        background: "transparent",
                        width: isLargeScreen ? "58.5%" : "100%",
                    }}
                >
                    <Offcanvas.Header
                        closeButton
                        style={{
                            backgroundColor: themeColors["--bg-primary"],
                            padding: "10px",
                            color: themeColors["--text-primary"],
                        }}
                    />
                    <Offcanvas.Body className="p-0">
                        <img
                            src={modalPath ? `${base_url}${modalPath}` : "/assets/paneal_images/banner_Default.webp"}
                            className="img-fluid w-100"
                        />
                    </Offcanvas.Body>
                </Offcanvas>
            </div>
        </>
    );
};

export default LoginModal;
